import { render, staticRenderFns } from "./editPaNotify.vue?vue&type=template&id=5d84ddce&"
import script from "./editPaNotify.vue?vue&type=script&lang=js&"
export * from "./editPaNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports